import React from 'react';
import styles from './styles.module.css';

const Module = ({ title, text }) => {
  return (
    <>
      <div className={styles.module}>
        <h6 className={styles.courseTitle}>{title}</h6>
        <ul className={styles.list}>
          {text.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </div>
    </>
  );
};

const ProgramDesktop = ({ program }) => (
  <>
    <div className={styles.root}>
      <h4 className={styles.title}>Куррикулум</h4>
      <div className={styles.grid}>
        {program.map((item, i) => (
          <Module key={i} title={item.title} text={item.text} />
        ))}
      </div>
    </div>
  </>
);

export default ProgramDesktop;
